@if (styleVariant() === 'round') {
    <button class="round-button" data-testid="WaltDetails-Ring" [disabled]="disabled()" (click)="playSound()">
        <app-icon [faIcon]="'far fa-volume'" [fontSize]="'18px'" style="font-weight: 400;" />
    </button>
} @else if (canEdit()) {
    <button class="blue-lt small w100p mT10 flexRow jcC" (click)="playSound()">
        <app-icon [faIcon]="'fas fa-volume-up'" [fontSize]="'20px'" />
        <p class="pL5">{{'walt.play-sound' | translate}}</p>
    </button>
}

@if (showSoundPopup()) {
    <div class="sound-popup" [class.sound-popup-round]="styleVariant() === 'round'">
        @if (soundPopupAction() === 'retry') {
            <app-icon class="sound-popup-close" faIcon="fas fa-times" [fontSize]="'18px'" (click)="dismissSoundPopup()" />
        }

        @if (soundFeedback().state === 'sending') {
            <div class="flex1 flexColumn jcC aiC fg1">
                <app-logo-spinner [size]="40" [diameter]="40" [slow]="false" [showMessage]="false" />
                <p class="sound-popup-message">{{soundPopupMessage() | translate}}</p>
            </div>
        } @else {
            @if (soundFeedback().state === 'playing' || soundFeedback().state === 'stopped') {
                <app-icon class="sound-popup-icon" faIcon="fas fa-music-alt" [fontSize]="'32px'" />
            } @else {
                <app-icon class="sound-popup-icon" faIcon="fas fa-exclamation-triangle" [fontSize]="'32px'" />
            }

            <div class="flex1 flexColumn jcC aiC fg1">
                <p class="sound-popup-message">{{soundPopupMessage() | translate}}</p>
            </div>

            @if (soundPopupAction() === 'stop') {
                <button class="blue-lt" (click)="stopSound()">{{'walt.play-sound-status.stop' | translate}}</button>
            } @else if (soundPopupAction() === 'retry') {
                <button class="blue-lt" (click)="retrySound()">{{'walt.play-sound-status.retry' | translate}}</button>
            }
        }
    </div>
}
